import type { ApolloCache } from '@frameio/graphql-client';
import { cacheModify } from '@frameio/graphql-client';
import type { Project } from '@frameio/graphql-client/generated';

/**
 * Updates the images for a project in the cache.
 *
 * @param cache the instance of the Apollo cache
 * @param project the id of the project and an updated object of images
 */
export function updateProjectImages(
  cache: ApolloCache<any>,
  project: Pick<Project, 'id' | 'images'>
) {
  const { id, images } = project;

  cacheModify<Project>(cache, {
    identify: {
      __typename: 'Project',
      id,
    },
    fields: {
      images: () => images,
    },
  });
}
